var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_51",
    "data-name": "Group 51",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100vw",
    height: 1144.063,
    viewBox: "0 0 100vw 1144.063",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M-136.917,622.577s317.947-76.96,464.532-86.8c187.328-12.569,276.331,55.685,454.318,52.1,135.953-2.743,223.513-119.509,449.116-130.284,121.259-5.794,249.466,22.516,338.469,90.156,96.977,73.726,213.565,74.83,213.565,74.83v978.341h-1920Z",
    transform: "translate(136.917 -456.856)",
    fill: "#70c0e1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M-136.917,622.253S48.132,529.968,194.718,520.128c187.328-12.568,409.228,101.664,587.215,98.078,135.953-2.743,204.528-150.159,430.13-160.934,121.259-5.794,268.452,53.17,357.455,120.808,96.977,73.723,213.565,44.173,213.565,44.173v978.309h-1920Z",
    transform: "translate(136.917 -456.5)",
    fill: "#102348"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorFooter);
export default __webpack_public_path__ + "static/media/error-footer.492548f4119c48bd528ed2d2179e36e3.svg";
export { ForwardRef as ReactComponent };